// @ts-check
import util from 'util';

/* eslint-disable no-console */

const debugLogger = {
  log(...rest) {
    if (process.env.NODE_ENV === 'development') {
      if (
        window.navigator.userAgent.indexOf('PhantomJS') > 0 ||
        window.navigator.userAgent.indexOf('capybara-webkit') > 0
      ) {
        rest.forEach(obj => {
          console.log(util.inspect(obj, { depth: 5 }));
        });
      } else {
        console.log(...rest);
      }
    }
  },
};

/* eslint-enable no-console */

export default debugLogger;
